const modalContent = {
    
    secondaryDescription: `
    <style>
   .section-header {
      font-size: 20pt;
      font-weight: 600;
      line-height: 0.4;
      margin: 0;
      padding: 0;
    }

    ul {
      line-height: 0.8;
      margin: 0;
      margin-bottom: 0px;
      padding-left: 20px;
    }

    @media (max-width: 589px) {
      ul {
        line-height: 0.7;
      }
      li {
        line-height: 2;
      }
    }
    
    li {
      margin-bottom: 0px;
      margin-top: 0px;
      line-height: 0.8 ;
    }

    p {
      line-height: 1.4;
      margin: 0;
      padding: 0;
      font-weight: 400;
      font-family: "Noto Sans";
    }

    strong {
      font-weight: 600;
    }
      </style>
  <h1>Rainmaker Star Aura</h1>
  <p style="margin-top: 1px;">Most fan experiences today are one-way. Posts, interviews, and chatbots don’t truly reflect the person behind them. Star Aura changes that.</p>
  <p style="margin-top: 26px;">Star Aura is the self-sovereign Personal AI of an artist, athlete, or creator — built with their permission and governed by them. It’s a persistent intelligence that carries forward their voice, perspective, and behavioral boundaries, allowing them to participate authentically across time and platforms.</p>
  <p style="margin-top: 26px; margin-bottom: -4px;">We’re <b>launching Star Aura with Grammy-winning producer Vassal Benford</b>, whose work has shaped icons including Rihanna, Michael Jackson, and Prince. His Aura reflects his creative journey, insights, and perspective, offering a new kind of connection between artist and audience.</p>
  
  <div style="font-style: italic; line-height: 1; margin-top: 0; margin-bottom: 15px;">
    <b>“ Star Aura isn’t a chatbot. It’s the personal AI created and governed by the artist themselves.”</b><br />
    <span style="display: block; text-align: right; font-weight: bold; margin-top: 0px;">- Vassal Benford</span>
  </div>
  <p style="margin-top: 0; margin-bottom: 11px; padding: 0;"><b>Why it matters</b> </br>For the first time, Personal AI belongs to the individual, not the platform.</p>

  <p style="margin-top: 0; margin-bottom: 11px; padding: 0;">Each Star Aura evolves with its creator while remaining aligned with who they are, ensuring authenticity, continuity, and control.</p>

  <p style="margin-top: 0; margin-bottom: 0; padding: 0;">This creates a deeper, more trusted relationship between creators and the people who follow them.</p>

  <p style="margin-top: 51px; margin-bottom: -18px; padding: 0;"><b>What fans get</b></br>Star Aura gives you direct access to the Personal AI of your favorite creators.</p>



<p style="margin: 0;">You can:</p>
<p style="margin: 0; padding: 0; line-height: 1;">● Have authentic interactions</p>
<p style="margin: 0; line-height: 1.2;">● Discover stories and insights in their own voice</p>
<p style="margin: 0; line-height: 1.2;">● Connect anytime through their persistent Aura powered AI</p>


  
 

  <p style="margin-top: -46px; margin-bottom: 51px; padding: 0;">Every interaction reflects who they are, not generic responses.</p>

  <p><b>What creators get</b></br>Star Aura allows creators to scale their presence without losing authorship or control.</p>
  
  <p style="margin-top: 11px; margin-bottom: 11px;">Their Aura remains self-sovereign and governed by them, enabling authentic connection with millions while preserving identity and intent.</p>
  
  <p>Be among the first to experience Star Aura
 `
};

export default modalContent;